import React, { FC, useMemo, useRef, useState } from 'react';

import {
    Spacer
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import {
    PageHeader,
    IconButton
} from '@components/2-molecules';


import { ForwardedPageProps } from '@lib/constants';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
import { useTax } from '@lib/hooks/useTax';

import Add from '@assets/icons/plus';
import Sandwich from '@assets/icons/sandwich';
import TaxList from '@components/3-organisms/Lists/ListTax';

const Taxes: FC<ForwardedPageProps> = ({ navigation, ...props }) => {

    // const [accounts] = useProductsServices({ /* id: data.id, */ message: 'Loading...', state: STATE.READY});
    const [taxes,] = useTax();

    return (
        <AppTemplate hooks={[taxes]}  >
        
            
            <PageHeader
                title={"TAXES"}
                left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
                /* menu={TaxesMenu navigation={navigation} />} */
                /* menuIcon={<Add />} */
            />
            <Spacer h={1} />
        
            
            <Spacer h={2} />
            <TaxList
                color={taxes?.data?.length ? '#000' : '#FFF'}
                data={taxes?.data}
            />

        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(Taxes);